/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import './ChatTransfer.css';
// availity-reactstrap-validation
import { AvForm } from "availity-reactstrap-validation";

// custom component
import Tabs from "./subcomponents/Tabs";
import CustomSelect from "./subcomponents/CustomSelect";
import SkillSelect from "./subcomponents/SkillSelect";

//i18n
import { withTranslation } from "react-i18next";

//Redux
import { useSelector, useDispatch } from "react-redux";

// actions
import {
  getTransferChats,
  transferChat,
  resetTransferChats,
} from "../../../../store/transferChat/actions";
import { resetAditionalFields } from "../../../../store/aditionalFields/actions";

const ChatTransfer = ({
  t,
  toggle,
  isOpen,
  conversationId,
  skillId,
  skillName,  
  clientName,
  onSubmit,
  isByManager,
}) => {
  const { transferable, status: transferStatus } = useSelector(
    (state) => state.TransferChat
  );
  const { messageOperator } = useSelector((state) => state.Operator);

  const dispatch = useDispatch();

  const [newPayload, setNewPayload] = useState({
    type: "skill",
    chatId: conversationId,
    enable_priority: false,
    skill: null,
    user: null,
  });
  const [listSkill, setListSkill] = useState([]);
  const [listAgent, setListAgent] = useState([]);
  const [skillIsPriority, setSkillIsPriority] = useState(false);
  const userPermissions =
    useSelector((state) => state.Login?.data?.permissions) || []; 
  const conversations = (useSelector((state) => state.Manager?.dataConversation?.message))?.find((cv)=> cv.id === conversationId) || null;
  
  const activeFlagPriority = useMemo(()=>{
    if(conversations && 
      conversations.channel_name === 'real_automation' &&
      isByManager &&
      newPayload?.type === 'skill'
      ){
        return true;
    }
    return false;
  },[conversations, isByManager, newPayload]);  

  const handleSkillIsPriorityRequest = useCallback(()=>{
    if(newPayload?.enable_priority){
      setSkillIsPriority((old)=> !old);
    }   
  },[setSkillIsPriority, newPayload]);

  const agentOption = (type, op) => {
    if (type === "skills") return op?.name;

    const conversationSkillId =
      messageOperator?.chats?.data?.find(
        (el) => el.conversationId === conversationId
      )?.skillId ?? skillId;

    const options = Object.entries(op?.skills?.[0]).map((el, key) => {
      const id = el[0];
      const name = el[1];

      const isDefault = conversationSkillId === id || skillName === name;

      return {
        key: key,
        value: id,
        label: name,
        default: isDefault,
      };
    });

    if (options.length > 0 && !options.find((el) => el.default === true)) {
      options[0].default = true;
    }
    
    const userItem = transferable?.users?.find((ag)=> ag.id === op.id) || {};
    let statusAgent = '';
    switch (userItem?.user_status) {
      case 'online':
        statusAgent = 'user-satus-online';
        break;
      case 'backsoon':
          statusAgent = 'user-status-pausa';
          break;
      case 'away':
            statusAgent = 'user-status-ausente';
            break;
    
      default:
        break;
    }  

    return (
      <div
        className="d-flex justify-content-between align-items-start"
        onClick={(e) => {
          e.stopPropagation();
          setNewPayload((prev) => ({
            ...prev,
            chatId: conversationId,
            skill: options.find((el) => el.default),
            user: { value: op.id, label: op.name },
          }));
        }}
      > 
        <div>
          <span className={`badge user-status-badge ${statusAgent}`}></span>
          <div className="user-name-chat">{op?.name}</div>
          <div className="user-number-chat">({userItem?.total_attendence}/{userItem?.max_chats})</div>
        </div>
        <div className="w-50">
          <SkillSelect
            options={options}
            placeholder={t("Skills")}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(e) => {
              options.forEach((item) => {
                item.default = item.value === e.value;
              });
              setNewPayload((prev) => ({
                ...prev,
                chatId: conversationId,
                skill: e,
                user: { value: op.id, label: op.name },
              }));
            }}
          />
        </div>
      </div>
    );
  };

  const getLists = (type) => {
    let op = [];

    if (transferStatus?.get_transfer_chats?.loading) {
      op.push({
        value: "loading",
        label: t("loading"),
        isDisabled: true,
      });
    } else if (transferable?.[type]?.length > 0) {
      op.push({
        value: "default",
        label: t("Select an option"),
        isDisabled: true,
      });

      transferable[type].map((transf, key) =>
        op.push({
          key: key,
          value: transf.id,
          label: agentOption(type, transf),
          isDisabled: type === "users",
        })
      );
    } else {
      op.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }

    return op;
  };

  const clearFields = useCallback(() => {
    setSkillIsPriority(false);
    setNewPayload((prev) => ({
      ...prev,
      chatId: conversationId,
      type: "skill",
      skill: null,
      enable_priority: false,
      user: null,
    }));
  },[setSkillIsPriority, setNewPayload]);

  const handleTransferChat = useCallback(() => {
    let aux = {};
    if (newPayload.type === "user") {
      aux = {
        userId: newPayload?.user?.value,
        skillId: newPayload?.skill?.value,
      };
    } else {
      aux = { skillId: newPayload?.skill?.value, enable_priority: skillIsPriority};
    }
    if (isByManager) {
      aux = { ...aux, byManager: true };
    }
    dispatch(transferChat(aux, newPayload?.type, newPayload?.chatId));

    dispatch(resetAditionalFields(newPayload?.chatId));
  },[dispatch, transferChat, newPayload, skillIsPriority]);

  const updateLists = () => {
    dispatch(getTransferChats(conversationId));
  };

  useEffect(() => {
    if (isOpen) {
      updateLists();
    }
  }, [isOpen]);

  useEffect(() => {
    setListAgent(getLists("users"));
    setListSkill(getLists("skills"));
    clearFields();

    if (transferStatus && transferStatus.transfer_chat) {
      let transfer_chat = transferStatus.transfer_chat;
      if (transfer_chat.success.status) {
        toggle();
        onSubmit({
          error: false,
          message: "Conversation transferred",
          chatId: transfer_chat.success.chatId,
          body: null,
        });
        dispatch(resetTransferChats("transfer_chat"));
      } else if (transfer_chat.error.status) {
        onSubmit({ error: true, message: transfer_chat.error.message, body:  transfer_chat?.error?.body ?? null });
        dispatch(resetTransferChats("transfer_chat"));
        updateLists();
      }
    }
  }, [transferStatus]);

  const filterOption = ({ label, value }, string) => {
    const stringLc = string?.toLowerCase();
    const customLabel = label?.props?.children[0]?.props?.children[1]?.props?.children;
    
    if (customLabel) {
      const customLabelLw = customLabel?.toLowerCase();
      if (customLabelLw?.includes(stringLc)) {
        return true;
      }
    } else {
      const labelLc = label?.toLowerCase();
      const valueLc = value?.toLowerCase();
      if (labelLc?.includes(stringLc) || valueLc?.includes(stringLc)) {
        return true;
      }
    }
    return false;
  };

  /**
   * @returns {boolean} if true the user is not allowed to transfer
   */
  const userNotAllowed = useCallback(() => {
    if (
      !(
        Array.isArray(userPermissions?.conversation) &&
        userPermissions?.conversation.includes("transfer")
      )
    ) {
      return true;
    }
    return false;
  }, [userPermissions]);

  const onChangeSelectedSkill = useCallback((e)=>{
    setSkillIsPriority(false);                  
    setNewPayload((prev) => ({
      ...prev,
      chatId: conversationId,
      skill: e,
      enable_priority: (transferable.skills.find((ele)=> ele.id === e.value))?.enable_priority ?? false,
      user: null,
    }))
  },[transferable]);

  const onChangeSelectedTabs = useCallback((opt)=>{
    if(newPayload.type !== opt){    
      setNewPayload((e) => ({
        ...e,
        type: opt,
        skill: null,
        user: null,
      }));
    }
  },[newPayload]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={!transferStatus?.transfer_chat?.loading}
        keyboard={!transferStatus?.transfer_chat?.loading}
      >
        {userNotAllowed() ? (
          <>
            <ModalHeader className="modal-header-no-button" toggle={toggle}>
              {t("Action not allowed")}
            </ModalHeader>
          </>
        ) : (
          <AvForm onValidSubmit={handleTransferChat}>
            <ModalHeader
              toggle={toggle}
              className={`px-4 pt-4 ${
                !transferStatus?.transfer_chat?.loading
                  ? ""
                  : "modal-header-no-button"
              }`}
            >
              <span className="text-left">
                {t("Transfer chat")}
                {clientName ? ` [${clientName}]` : ""}
              </span>
            </ModalHeader>
            <ModalBody className="px-4">
              <Row>
                <Col sm="6">
                  <Tabs
                    onChange={onChangeSelectedTabs}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col sm="12">
                  <CustomSelect
                    className={`${newPayload.type}-type`}
                    placeholder={
                      newPayload.type === "user"
                        ? t("Search agent")
                        : t("Search skill")
                    }
                    filterOption={filterOption}
                    options={newPayload.type === "user" ? listAgent : listSkill}
                    value={
                      newPayload.type === "user"
                        ? newPayload?.user && {
                            value: newPayload?.user?.value,
                            label: `${newPayload?.user?.label} - ${newPayload?.skill?.label}`,
                          }
                        : newPayload?.skill
                    }
                    onChange={onChangeSelectedSkill}
                    isLoading={transferStatus?.get_transfer_chats?.loading}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className="px-4 pb-4">
              {
                activeFlagPriority ? (
                  <Col sm="12">
                  <div className="custom-control custom-checkbox">
                    <input                  
                      type="checkbox"
                      name={`skillqueuepriority`}
                      className="custom-control-input"                  
                      checked={skillIsPriority}                  
                    />
                    <label
                      className="custom-control-label"
                      style={ !newPayload?.enable_priority ? {cursor: 'not-allowed'}: {}}
                      id="power-checkbox"
                      onClick={handleSkillIsPriorityRequest}
                    >
                      {t("Set as high priority")}
                    </label>
                  </div>
                  </Col>
                ) : null
              }
              <button
                type="button"
                onClick={toggle}
                className="btn waves-effect waves-light btn-dark"
                data-dismiss="modal"
                disabled={transferStatus?.transfer_chat?.loading}
              >
                {t("Cancel")}
              </button>

              {transferStatus?.transfer_chat?.loading ? (
                <button
                  type="button"
                  color="primary"
                  className="btn btn-primary waves-effect waves-light"
                >
                  <Spinner size="sm" animation="border" />
                </button>
              ) : (
                <button
                  type="submit"
                  color="primary"
                  className="btn btn-primary waves-effect waves-light"
                  disabled={!newPayload?.skill}
                >
                  {t("Transfer")}
                </button>
              )}
            </ModalFooter>
          </AvForm>
        )}
      </Modal>
    </>
  );
};
export default withTranslation()(ChatTransfer);
